import { Menu } from "antd";
import { ErrorBoundary } from "react-error-boundary";
import { RedoOutlined, AuditOutlined } from "@ant-design/icons";
import {
  ProjectOutlined,
  DatabaseOutlined,
  ReconciliationOutlined,
  HistoryOutlined,
} from "@ant-design/icons";

import ErrorFallback from "components/ErrorFallback";

import { theme } from "styles/theme";

import { RouteItem, StyledNavLink, LogoPlaceholder, SidebarContainer } from "./styled";

function Sidebar() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <SidebarContainer width={270} zeroWidthTriggerStyle={{ background: theme.primary.main }}>
        <LogoPlaceholder>NEFT SETTLEMENT</LogoPlaceholder>
        <Menu
          mode="inline"
          defaultSelectedKeys={["2"]}
          style={{ background: theme.primary.main, border: "none" }}
        >
          <StyledNavLink to="/generation">
            <RouteItem>
              <DatabaseOutlined />
              <p>Data Generation</p>
            </RouteItem>
          </StyledNavLink>

          <StyledNavLink to="/t-plus-one-processing">
            <RouteItem>
              <ProjectOutlined />
              <p>T + 1 Processing</p>
            </RouteItem>
          </StyledNavLink>

          <StyledNavLink to="/reprocess">
            <RouteItem>
              <RedoOutlined />
              <p>Re-Process</p>
            </RouteItem>
          </StyledNavLink>

          <StyledNavLink to="/request-history" style={{display: "none"}}>
            <RouteItem>
              <HistoryOutlined />
              <p>Request History</p>
            </RouteItem>
          </StyledNavLink>

          <StyledNavLink to="/report">
            <RouteItem>
              <ReconciliationOutlined />
              <p>Report</p>
            </RouteItem>
          </StyledNavLink>

          <StyledNavLink to="/audit">
            <RouteItem>
              <AuditOutlined />
              <p>Audit</p>
            </RouteItem>
          </StyledNavLink>
        </Menu>
      </SidebarContainer>
    </ErrorBoundary>
  );
}

export default Sidebar;
